
/* injects from baggage-loader */

export const getSportsListSubscriptionRequest = (provider) => {
    return {
        "source": "betting",
        "what": {
            "sport": ["id", "name", "alias", "order"]
        },
        "where": {
            "game": {
                "@or": [
                    {
                        "type": 0
                    },
                    {
                        "visible_in_prematch": true,
                        "type": 4
                    }
                ]
            },
            "sport": {
                "id": {
                    "@in": getSportIds(provider)
                }
            }
        },
        "subscribe": true
    };
};

const getSportIds = provider => {
    return {
        "Betconstruct": [54, 55, 56, 118, 150, 173, 174],
        "Inspired": [132, 133, 134, 135, 136, 137, 138]
    }[provider];
};

export const getCompetitionsSubscriptionRequest = (sportId) => {
    return {
        "source": "betting",
        "what": {
            "competition": ["id", "name", "order"]
        },
        "where": {
            "game": {
                "@or": [{
                    "type": 0
                }, {
                    "visible_in_prematch": true,
                    "type": 4
                }
                ]
            },
            "sport": {
                "id": sportId
            }
        },
        "subscribe": true
    };
};

export const getGamesSubscriptionRequest = (competitionId) => {
    return {
        "source": "betting",
        "what": {
            "game": ["game_number", "team1_name", "team2_name", "id", "start_ts", "text_info", "video_id", "round"],
            "market": "@count"
        },
        "where": {
            "competition": {
                "id": competitionId
            },
            "game": {
                "@or": [{
                    "type": 0
                }, {
                    "visible_in_prematch": true,
                    "type": 4
                }
                ]
            }
        },
        "subscribe": true
    };
};

export const getVirtualGameVideo = (videoId, provider) => {
    return {
        "video_id": videoId,
        "provider": provider
    };
};